<script setup lang="ts">
import { VERSION } from '@cinqo/common'
import { RotateCcwIcon } from 'lucide-vue-next'
import { hotReload } from '~/helpers/UtilsHelper'

async function hotReloadApp() {
  await hotReload()
}
</script>

<template>
  <div class="h-full w-full flex flex-col">
    <!-- Mobile header skeleton -->
    <div class="w-full bg-base-200 p-4 flex items-center justify-between">
      <div class="skeleton h-8 w-24" />
      <div class="skeleton h-8 w-8 rounded-full" />
    </div>

    <!-- Main content skeleton -->
    <div class="flex-1 p-4 flex flex-col gap-4 overflow-y-auto">
      <!-- Title skeleton -->
      <div class="skeleton h-8 w-full max-w-sm mb-4" />

      <!-- Subtitle skeleton -->
      <div class="skeleton h-6 w-full max-w-xs mb-4" />

      <!-- Content blocks optimized for mobile -->
      <div class="skeleton h-32 w-full mb-4" />

      <!-- Stacked cards for mobile -->
      <div class="flex flex-col gap-3 mb-4">
        <div class="skeleton h-20 w-full" />
        <div class="skeleton h-20 w-full" />
        <div class="skeleton h-20 w-full" />
      </div>

      <!-- List items skeleton -->
      <div class="flex flex-col gap-2">
        <div class="skeleton h-12 w-full" />
        <div class="skeleton h-12 w-full" />
        <div class="skeleton h-12 w-full" />
        <div class="skeleton h-12 w-full" />
      </div>
    </div>

    <!-- Mobile bottom navigation skeleton -->
    <div class="w-full bg-base-200 p-4 flex justify-around items-center">
      <div class="skeleton h-8 w-8 rounded-full" />
      <div class="skeleton h-8 w-8 rounded-full" />
      <div class="skeleton h-8 w-8 rounded-full" />
      <div class="skeleton h-8 w-8 rounded-full" />

      <!-- Version info -->
      <div class="flex items-center gap-2">
        <RotateCcwIcon
          :size="20"
          class="text-base-content cursor-pointer"
          @click="hotReloadApp"
        />
        <span class="text-xs">{{ VERSION }}</span>
      </div>
    </div>
  </div>
</template>
